import Vue from 'vue';
import Vuesax from 'vuesax';
var colors = {
  primary: '#141E47',
  secondary: '#0F437B',
  success: '#28C76F',
  danger: '#EA5455',
  warning: '#FF9F43',
  dark: '#1E1E1E'
};
var theme = {
  disableCustomizer: true,
  disableThemeTour: false,
  footerType: 'hidden',
  // static(default) / sticky / hidden
  hideScrollToTop: false,
  mainLayoutType: 'vertical',
  // vertical(default) / horizontal
  navbarColor: '#fff',
  // HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType: 'sticky',
  // floating(default) / static / sticky / hidden
  routerTransition: 'zoom-fade',
  // zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  rtl: true,
  sidebarCollapsed: false,
  theme: 'light' // light(default) / dark / semi-dark

};
Vue.use(Vuesax, {
  theme: {
    colors: colors
  },
  rtl: theme.rtl
});
export default theme;